import { normalisePillars } from "../../form/utils";
import { parseTimestamp } from "../../formatting/date-time-manipulation";
import type { SolutionPayload } from "../../types";
import type { AddSolutionFormValues } from "./types";

export const createAddSolutionPayload = (
  form: AddSolutionFormValues,
): SolutionPayload => ({
  name: form["solution-name"],
  vbcWebsiteDisplayName: form["solution-vbc-website-display-name"],
  developer: form["solution-developer"] || null,
  shortDescription: form["solution-short-description"] || null,
  country: form["country-select"] || [],
  coordinates: {
    latitude: Number.parseFloat(form.latitude),
    longitude: Number.parseFloat(form.longitude),
  },
  developmentStage: form["solution-development-stage"] || [],
  assessmentMethodology: form["solution-assessment-methodology"] || null,
  interventionType: form["solution-intervention-type"] || null,
  SDG: form["solution-sdg"] || [],
  date: {
    start: parseTimestamp(form["solution-start-date"]),
    end: parseTimestamp(form["solution-end-date"]),
  },
  isReadyForSale: form["solution-is-ready-for-sale"] || false,
  notReadyForSaleReason: form["solution-is-ready-for-sale"]
    ? undefined
    : form["solution-not-ready-for-sale-reason"] || undefined,
  isUsedForCarbonOffsetting: form["solution-is-carbon-offset"] || false,
  interventions: form.interventions.map((intervention) => ({
    action: intervention.action || [],
    ecosystem: intervention.ecosystem || [],
  })),
  outcomes: form.outcomes.map((outcome) => ({
    value: Number.parseFloat(outcome.value),
    unit: outcome.unit,
    isUnitOfSale: outcome["unit-of-sale"],
    startDate: parseTimestamp(outcome["outcome-start-date"]),
    endDate: parseTimestamp(outcome["outcome-end-date"]),
  })),
  pillars: normalisePillars(form.pillars),
  programmeInfo: {
    carbonCreditProgramme:
      form["programme-info"]["carbon-crediting-programme"] || [],
    projectDescriptionDocument:
      form["programme-info"]["description-document"] || null,
    accountingMethodology:
      form["programme-info"]["carbon-accounting-methodology"] || null,
    assetType: form["programme-info"]["asset-type"] || null,
  },
  internalUseOnly: {
    websiteUrl: form["internal-details"]["website-url"] || null,
    xeroAccountNumber: form["internal-details"]["xero-account-number"] || null,
    researchTeamNotes: form["internal-details"]["research-team-notes"] || null,
    additionalResourceLink:
      form["internal-details"]["additional-resources-link"] || null,
  },
  commercialInformation: {
    minimumOrder:
      form["commercial-information"]["minimum-order"] == null
        ? null
        : Number(form["commercial-information"]["minimum-order"]),
  },
  satelliteImagery: form["satellite-imagery"]
    .filter(
      (satelliteImage) => satelliteImage.mediaLink || satelliteImage.caption,
    )
    .map(({ mediaLink, caption }) => ({ mediaLink, caption })),
  locationPinMapLink: form["location-pin-map-link"] || null,
  narrative: {
    projectInformation: form.narrative["project-information"],
    areaThroughTime: form.narrative["area-through-time"],
    goodForPeople: form.narrative["good-for-people"],
    goodForEarth: form.narrative["good-for-earth"],
  },
  riskMonitoring: {
    isEnabled: form["risk-monitoring"]["is-risk-alert-enabled"] || false,
    buffer: form["risk-monitoring"]["buffer-value-km"] || 10,
    geospatialFile: form["risk-monitoring"]["geospatial-file"] || null,
  },
});
